<script setup>
import { ref } from "vue";
import UserEditModal from "../../components/modals/UserEditModal";
import ConfirmModalVue from "../modals/ConfirmModal.vue";
import { deleteUser } from '../../functions/Users'
import { useAuthStore } from "../../stores/auth";

const authStore = useAuthStore();

const props = defineProps({
    user: {
        type: Object,
        default: null,
    },
});

const collapsed = ref(true);
</script>

<template>
    <div class="user-single">
        <div class="user-single__header" :class="{ active: !collapsed }" @click="collapsed = !collapsed">
            <img :src="user.avatar_url" :alt="`Profile picture for ${user.name}`" />
            <p class="name">{{ user.name }}</p>
            <svg-vue icon="arrow-toggle"></svg-vue>
        </div>
        <div class="user-single__content" v-if="!collapsed">
            <h1>{{ user.name }}</h1>
            <p><a :href="`mailto:${user.email}`">{{ user.email }}</a></p>
            <br />
            <p>
                <strong>Last active:</strong> {{ user.last_active }}
            </p>
            <div class="buttons">
                <UserEditModal :user="user"></UserEditModal>
                <template v-if="authStore.currentUser.id != user.id">
                    <ConfirmModalVue :method="deleteUser" :args="user.id" :btn-content="'Delete'" />
                </template>
            </div>

        </div>
    </div>
</template>

<style scoped lang="scss">
@import '../../../scss/partials/variables';

.user-single {
    border-bottom: 1px solid var(--grey-lighter);

    &:last-child {
        border-bottom: none;
    }

    &__header {
        display: flex;
        align-items: center;
        padding: 20px 0;
        cursor: pointer;
        transition: 0.3s ease;

        svg {
            margin-left: auto;
            width: 15px;
            height: 15px;
            transform: rotate(-90deg);
            transition: 0.3s ease;
        }

        &:hover,
        &.active {
            background-color: var(--grey-lighter);
            padding: 20px;
        }

        &.active svg {
            transform: rotate(0deg);
        }

        img {
            border-radius: 50%;
            width: 32px;
            height: 32px;
            margin: 0 var(--grid-gap) 0 0;
        }
    }

    &__content {
        padding: 20px;

        .buttons {
            margin-top: 20px;
            width: 320px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;

            @media screen and (max-width: $breakpoint-md) {
                width: 100%;
            }
        }
    }
}
</style>
